import { createVuetify } from "vuetify";
import "vuetify/styles";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import i18n from "./i18n";
import { useI18n } from "vue-i18n";

const vuetify = createVuetify({
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          primary: "#2b5e7d",
          secondary: "#7CC7CA",
          accent: "#E63946",
          info: "#00CAE3",
          success: "#2e7d32",
          warning: "#EACB00",
          error: "#E63946",
          background: "#ffffff",
          surface: "#ffffff",
          muted: "#999999",
          text: "#1a1a1a",
          textStrong: "#000000",
          border: "#e6e6e6",
          borderSoft: "#f0f0f0",
          surfaceSoft: "#f1f5f1",
          surfaceBright: "#ffffff",
          surfaceInfo: "#e8f4f8",
          surfaceSuccess: "#e6f4ea",
          inactive: "#6c757d",
          danger: "#c62828",
          chipPrimary: "#8ad3ff",
          chipSuccess: "#8fecc2",
          chipWarning: "#ffd792",
          chipDanger: "#ffb3b3",
          hover: "#ececec",
        },
        dark: false,
      },
      dark: {
        colors: {
          primary: "#457b9d",
          secondary: "#7CC7CA",
          accent: "#E63946",
          info: "#00CAE3",
          success: "#2e7d32",
          warning: "#EACB00",
          error: "#E63946",
          background: "#ffffff",
          surface: "#ffffff",
          muted: "#999999",
          text: "#1a1a1a",
          textStrong: "#000000",
          border: "#e6e6e6",
          borderSoft: "#f0f0f0",
          surfaceSoft: "#f1f5f1",
          surfaceBright: "#ffffff",
          surfaceInfo: "#e8f4f8",
          surfaceSuccess: "#e6f4ea",
          inactive: "#6c757d",
          danger: "#c62828",
          chipPrimary: "#8ad3ff",
          chipSuccess: "#8fecc2",
          chipWarning: "#ffd792",
          chipDanger: "#ffb3b3",
          hover: "#ececec",
        },
        dark: true,
      },
    },
  },
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n }),
    locale: i18n.global.locale.value as string,
  },
});

export default vuetify;
